import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = null as null | string;

const slice = createSlice({
  name: 'hqGatewayKey',
  initialState,
  reducers: {
    setHqGatewayKey(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setHqGatewayKey } = slice.actions;

export default slice.reducer;
